<template>
  <div>
    <div v-if="selectSummaryText[shopId]" style="font-size: 13px;">{{ shopName }}：{{ selectSummaryText[shopId] }}</div>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  computed: {
    selectSummaryText() {
      return this.$store.getters['ConvertSummary/getSelectSummaryText']
    },
    shopName() {
      return this.$store.getters['ConvertSummary/getShopName']
    },
    shopId() {
      return this.$store.getters['ConvertSummary/getShopId']
    },
  },
}
</script>

<style lang="scss" scoped></style>
